import { Button, Dialog, DialogContent, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import usePaymentContext from '../hook/usePaymentContext'
import { PaymentDisplaySection } from '../hook/SectionType'
import { SxProps } from '@mui/system'
import { GiftCardDetailContract } from 'models'
import CloseDialogButton from 'components/Dialog/CloseDialogButton'

const style: { [name: string]: SxProps } = {
    button: {
        height: 50,
        textTransform: 'uppercase',
        minWidth: 135,
    } as SxProps,
}
const PayButton = ({
    isExpired,
    onClickTopup,
    giftcardDetail,
    payButtonText = 'Pay with this card',
}: {
    isExpired: boolean
    onClickTopup: () => void
    giftcardDetail: GiftCardDetailContract
    payButtonText?: string
}) => {
    const {
        onSetDisplaySection,
        expectAmount,
        isSplitPayment,
        onQuickSplitGiftCardPayment: onSplitGiftCardPayment,
        onSelectGiftCard,
    } = usePaymentContext()
    const [open, setOpen] = useState(false)
    const onPay = () => {
        if (expectAmount.toNumber() > (giftcardDetail.currentBalance ?? 0))
            setOpen(true)
        else {
            onSelectGiftCard(giftcardDetail)
            onSetDisplaySection(PaymentDisplaySection.Calculation)
        }
    }
    return (
        <>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <CloseDialogButton
                    dialogName="pay dialog"
                    onClick={() => setOpen(false)}
                />
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Button
                                color={'bluegrey'}
                                sx={{
                                    height: 150,
                                    width: 150,
                                    fontSize: '18px',

                                    '&:hover': {
                                        boxShadow: 'none',
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                                disabled={!giftcardDetail.canTopup}
                                onClick={() => {
                                    onClickTopup()
                                    setOpen(false)
                                }}
                            >
                                <Typography style={{ fontSize: 16 }}>
                                    Top up
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                disabled={
                                    (giftcardDetail.currentBalance ?? 0) === 0
                                }
                                color={'bluegrey'}
                                sx={{
                                    height: 150,
                                    width: 150,
                                    fontSize: '18px',

                                    '&:hover': {
                                        boxShadow: 'none',
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                                onClick={() =>
                                    onSplitGiftCardPayment(giftcardDetail)
                                }
                            >
                                <Typography style={{ fontSize: 16 }}>
                                    Split Payment
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <Button
                onClick={onPay}
                color="primary"
                sx={style.button}
                disabled={
                    isExpired ||
                    (isSplitPayment &&
                        expectAmount.toNumber() >
                            (giftcardDetail?.currentBalance ?? 0)) ||
                    ((giftcardDetail?.currentBalance ?? 0) === 0 &&
                        !(giftcardDetail.canTopup ?? false))
                }
            >
                {payButtonText}
            </Button>
        </>
    )
}

export default PayButton
